import script from "./UsersTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./UsersTable.vue?vue&type=script&setup=true&lang=ts"

import "./UsersTable.vue?vue&type=style&index=0&id=cbc78eb2&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbc78eb2"]])

export default __exports__